
import React, { useEffect } from 'react';
import './LineItems.css';

function LineItems({ items, onUpdate }) {
  useEffect(() => {
    console.log('LineItems re-rendered with items:', items);
  }, [items]);
  
  const handleChange = (index, field, value) => {
    onUpdate(field, value, index);
  };

  // Collect all unique keys from all items
  const allFields = Array.from(
    new Set(items.flatMap(item => Object.keys(item)))
  ).filter(field => field !== 'Invoice Line Item Number');

  return (
    <div className="line-items">
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            {allFields.map((key) => (
              <th key={key}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              {allFields.map((field) => (
                <td key={field}>
                  <input
                    type="text"
                    value={item[field] || ''}
                    onChange={(e) => handleChange(index, field, e.target.value)}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LineItems;
